import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {DistributionAccount} from '../../../../distribution-account/distribution-account.model';
import {TtdCategory} from '../../../../target/target.service';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {debounceTime, filter, map, startWith} from 'rxjs/operators';
import {SubSink} from 'subsink';

@Component({
  selector: 'app-segment-share-item-ttd',
  template: `
    <mat-checkbox *ngIf="!hideAccountSelectCheckBox"
                  [(ngModel)]="accountValue.selected"
                  data-cy="checkbox-account-select"
                  name="account-select-checkbox">{{ accountValue.description }}
    </mat-checkbox>

    <mat-form-field>
      <mat-label>Choose Parent Category</mat-label>
      <input type="text"
             placeholder="Enter category"
             matInput
             [formControl]="myControl"
             [matAutocomplete]="auto"
             name="category">
      <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn">
        <mat-option *ngFor="let category of filteredOptions | async" [value]="category">
          <div class="option-text">
            <span>{{ category.displayName }}</span>
          </div>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

  `,
  styleUrls: ['./ttd.component.scss']
})
export class SegmentShareItemTtdComponent implements OnInit, OnDestroy {

  @Input() hideAccountSelectCheckBox = false;

  @Input() accountValue!: DistributionAccount;

  @Input() categories!: TtdCategory[];

  @Output() changed = new EventEmitter<TtdCategory>();
  myControl = new FormControl();
  filteredOptions!: Observable<TtdCategory[]>;
  private subSink = new SubSink();

  constructor() {
  }

  ngOnInit(): void {
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => (typeof value === 'string' ? value : value.displayName)), // switch value to name
      map(value => this._filter(value)),
    );
    this.subSink.sink = this.myControl.valueChanges.pipe(
      debounceTime(500),
      filter(value => value.providerElementId !== undefined)
    ).subscribe((value: TtdCategory) => {
      this.accountValue.ttdCategoryId = value.providerElementId;
      this.changed.emit(value);
    });
  }

  ngOnDestroy() {
    this.subSink.unsubscribe();
  }


  displayFn(category: TtdCategory): string {
    return category && category.displayName ? category.displayName : '';
  }

  private _filter(value: string = ''): TtdCategory[] {
    const filterValue = value.toLowerCase();

    return (this.categories || [])
      .filter(option => option.displayName.toLowerCase().includes(filterValue))
      .sort((a, b) => {
        const aName = a.displayName.toLocaleLowerCase();
        const bName = b.displayName.toLocaleLowerCase();
        if (aName < bName) {
          return -1;
        }
        if (aName > bName) {
          return 1;
        }
        return 0;
      });
  }
}
